import 'babel-polyfill';



// WEBPACK FOOTER //
// ./client/polyfills.js